// @flow
import React from 'react';

import {CodeTabGroup, CodeBlock, CodeTab} from 'docs/components';
import {ContentGroupItem} from 'docs/util';
import CollapsibleJson from '../StripeClui/components/CollapsibleJson';
import {useApiExplorer} from './ApiExplorerProvider';

export const ApiResponse = () => {
  const {
    state: {apiResponse},
  } = useApiExplorer();

  if (apiResponse?.error) {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            '',
            '',
            (
              <CodeTab key="api-response" id="api-response" title="Response">
                <CodeBlock numbered={false}>{apiResponse.error}</CodeBlock>
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_response"
      />
    );
  } else if (apiResponse?.response) {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            'json',
            'JSON',
            (
              <CodeTab key="api-response" id="api-response" title="Response">
                <CollapsibleJson data={apiResponse.response} />
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_response"
      />
    );
  } else {
    return (
      <CodeTabGroup
        items={[
          new ContentGroupItem(
            '',
            '',
            (
              <CodeTab key="api-response" id="api-response" title="Response">
                <CodeBlock>{null}</CodeBlock>
              </CodeTab>
            ),
          ),
        ]}
        codeTabGroupID="codetab_api_explorer_response"
      />
    );
  }
};
